import { loadScript } from '@opten/script/load-script';

export class Recaptcha3Validator {
	private submit: HTMLElement;
	private siteKey: string;
	private actionName: string;

	constructor(private element: HTMLInputElement) {
		this.submit = this.element
			.closest('form')
			.querySelector('[type=submit]');
		this.siteKey = this.element.getAttribute('data-site-key');
		this.actionName = this.element.getAttribute('data-action-name');

		let scriptUrl =
			'//www.google.com/recaptcha/api.js?render=' + this.siteKey;
		const culture = document.documentElement.lang;
		if (culture) {
			scriptUrl += '&hl=' + culture;
		}

		loadScript(scriptUrl)
			.then(() => {
				this.init();
			})
			.catch((exc) => console.error('catch', exc));
	}

	private init() {
		// Disable the submit button for this form, until we actually have a key from Google reCAPTCHA
		this.element.form.querySelector('[type=submit]').setAttribute('disabled','disabled');

		grecaptcha.ready(() => {
			this.timerFunction();
		});

		// var form = this.element.closest('form');
		// form.addEventListener('submit', (e) => {
		// 	e.preventDefault();
		// 	grecaptcha.ready(() => {
		// 		grecaptcha
		// 			.execute(this.siteKey, { action: this.actionName })
		// 			.then((token) => {
		// 				this.element.value = token;
		// 				form.submit();
		// 			});
		// 	});
		// });
	}

	private timerFunction() {
		grecaptcha
			.execute(this.siteKey, {
				action: this.actionName,
			})
			.then((token) => {
				 // Enable the submit button now we have a token
				this.element.form.querySelector('[type=submit]').removeAttribute('disabled');                        
				this.element.value = token;
			});
		setTimeout(() => this.timerFunction(), 60 * 1000);
	}
}

export default function recaptchaValidator(
	element: HTMLInputElement
): Recaptcha3Validator {
	return new Recaptcha3Validator(element);
}
